import script from "./DataCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DataCard.vue?vue&type=script&setup=true&lang=js"

import "./DataCard.vue?vue&type=style&index=0&id=3ed46d76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ed46d76"]])

export default __exports__